function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { watch, computed, defineComponent, reactive } from "vue";
import TableList from "@/components/TableList/index.vue";
import { definePropType } from "@types-vue/props";
import { historyColumn, accountColumn } from "@/views/producer/ics-authorization/authorization-option";
import { operationHistory, subAccounts } from "@/api/ics_advertiser/manage";
export default defineComponent({
    props: {
        visible: {
            type: definePropType(Boolean),
            default: false,
            required: true
        },
        action: {
            type: definePropType(String),
            default: "history",
            required: true
        },
        accountId: {
            type: definePropType(Number),
            required: true
        }
    },
    components: {
        TableList: TableList
    },
    setup: function setup(props, param) {
        var emit = param.emit, attrs = param.attrs;
        var tableDialog = reactive({
            tableColumnDialog: [],
            tableListDialog: [],
            listLoading: false
        });
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
                emit("update:accountId", 0);
            }
        });
        var dialogAttrs = computed(function() {
            return _objectSpread({
                title: props.action === "history" ? "\u5386\u53F2\u8BB0\u5F55" : "\u8D26\u53F7\u4FE1\u606F"
            }, attrs);
        });
        watch(function() {
            return props.accountId;
        }, function(val) {
            if (val) {
                tableDialog.tableListDialog = [];
                // eslint-disable-next-line no-use-before-define
                getInitData(val);
            }
        });
        var getInitData = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(ssUid) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            tableDialog.listLoading = true;
                            ;
                            if (!(props.action === "history")) {
                                _ctx.next = 9;
                                break;
                            }
                            tableDialog.tableColumnDialog = historyColumn;
                            _ctx.next = 6;
                            return operationHistory(ssUid);
                        case 6:
                            res = _ctx.sent;
                            _ctx.next = 13;
                            break;
                        case 9:
                            tableDialog.tableColumnDialog = accountColumn;
                            _ctx.next = 12;
                            return subAccounts(ssUid);
                        case 12:
                            res = _ctx.sent;
                        case 13:
                            tableDialog.tableListDialog = res.data.data;
                            tableDialog.listLoading = false;
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getInitData(ssUid) {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            dialogVisible: dialogVisible,
            dialogAttrs: dialogAttrs,
            tableDialog: tableDialog
        };
    }
});
